export default "__VITE_ASSET__CLMrDIu___"